<template>
  <div class="assessment-notice">
    <div class="wrapper">
      <div class="girl-bg" />
      <div class="description">
        {{ $t('coursesDetail.assessmentNotice.tips') }}
      </div>
      <a class="button btn-primary" :href="testUrl" target="_blank">
        {{ $t('coursesDetail.assessmentNotice.btnText') }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    testUrl: {
      default: '',
      type: String,
    },
  },
}
</script>
<style lang="scss" scoped>
.assessment-notice {
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 80px;
  background: rgba(0, 0, 0, 0.6);

  .wrapper {
    position: relative;
    height: 80px;
  }

  .girl-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 172px;
    height: 134px;
    background: url("~assets/images/courses/girl-bg.png") no-repeat;
    background-size: 100%;
  }

  .description {
    margin: 0 200px 0 180px;
    padding: 15px 0;
    line-height: 25px;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
  }

  .button {
    position: absolute;
    right: 0;
    top: 21px;
    height: 38px;
    padding: 0 20px;
    line-height: 38px;
    text-align: center;
    border-radius: 20px;
    cursor: pointer;
    background-color: var(--txt-color-link);

    &:hover {
      background-color: var(--txt-color-link2);
    }
  }
}
</style>
